import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './philanthropy.css';

import buttonArrow from '../../assets/icons/button-arrow.svg';
import philanthropyHands from '../../assets/philanthropy-hands.png';
import philanthropyChildren from '../../assets/philanthropy-children-heart.png';
import { sendContactEmail } from '../../utils/emailjs';

const Philanthropy = () => {
  const navigate = useNavigate();
  const [newsletterForm, setNewsletterForm] = useState({
    name: '',
    email: '',
    introduction: '',
  });

  const handleNavigateToInquiryForm = () => {
    navigate('/sell-your-business#kw-sell-inquiry');
  };

  useEffect(() => {
    const previousBackground = document.body.style.background;
    document.body.style.background = '#FFFFFF';
    document.body.classList.add('kw__page-hide-backtotop');

    return () => {
      document.body.style.background = previousBackground;
      document.body.classList.remove('kw__page-hide-backtotop');
    };
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setNewsletterForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await sendContactEmail(newsletterForm, 'Philanthropy Newsletter');
    setNewsletterForm({
      name: '',
      email: '',
      introduction: '',
    });
  };

  return (
    <div className="kw__philanthropy-page">
      <section className="kw__philanthropy-top kw__philanthropy-section">
        <p className="kw__philanthropy-outline">Philanthropy</p>

        <div className="kw__philanthropy-hero-copy">
          <h1>Turning Clear Purpose Into Outcomes That Truly Matter</h1>
          <p>
            Social responsibility is structured as a disciplined extension of long-term institutional thinking. The objective is not distribution,
            but durable transformation-built through systems, accountability, and measurable outcomes. Every initiative is designed to strengthen
            foundational social infrastructure with consistency and scale.
          </p>
        </div>
      </section>

      <section className="kw__philanthropy-impact">
        <img src={philanthropyHands} alt="" className="kw__philanthropy-impact-image" aria-hidden="true" />

        <div className="kw__philanthropy-section kw__philanthropy-impact-inner">
          <h2>
            Empowering Communities, Engineering
            <br />
            Sustainable Social Change
          </h2>
          <p>
            True corporate leadership extends far beyond market footprint-it is measured by the lasting, positive impact left on society. Through
            our dedicated philanthropic arm, the JB Foundation, we channel resources directly into high-impact social initiatives. By prioritizing
            access to quality healthcare, creating robust educational opportunities, and supporting community development programs, we work to
            dismantle socioeconomic barriers and foster a more resilient, equitable future.
          </p>
        </div>
      </section>

      <section className="kw__philanthropy-legacy kw__philanthropy-section">
        <div className="kw__philanthropy-legacy-copy">
          <h2>Building Legacies through Purpose-Driven Development</h2>
          <p>
            Sustainable social progress relies on more than short-term relief-it requires deep institutional investments that empower generations to
            thrive independently. Our focus remains on expanding our humanitarian reach while upholding absolute transparency and corporate empathy.
            We actively collaborate with leading healthcare institutions, transparent educational networks, and grassroots community organizations to
            scale our impact. This philanthropic platform is purpose-built for civic partners, global donor networks, and social advocates who
            understand that corporate growth only achieves its true purpose when it lifts society under continuous economic pressures.
          </p>
        </div>

        <img src={philanthropyChildren} alt="" className="kw__philanthropy-legacy-image" aria-hidden="true" />
      </section>

      <section className="kw__philanthropy-cta kw__philanthropy-section">
        <h2>Ready to Create Lasting Social Impact?</h2>
        <p>
          If you are looking to collaborate on grassroots community welfare, partner on corporate CSR initiatives, or work with our dedicated social
          impact team, let&apos;s shape a better future together.
        </p>
        <button type="button" className="kw__philanthropy-cta-btn" onClick={handleNavigateToInquiryForm}>
          <span>Let&apos;s Connect to Discuss</span>
          <img src={buttonArrow} alt="" />
        </button>
      </section>

      <section className="kw__philanthropy-newsletter kw__philanthropy-section">
        <div className="kw__philanthropy-news-copy">
          <p className="kw__philanthropy-news-label">Newsletter</p>
          <h3>Never Miss an Update</h3>
          <p>
            Subscribe to our corporate newsletter to receive quarterly highlights, industry research, and exclusive event invitations directly to
            your inbox.
          </p>
        </div>

        <form className="kw__philanthropy-news-form" onSubmit={handleSubmit}>
          <div className="kw__philanthropy-news-row">
            <input name="name" placeholder="Name" value={newsletterForm.name} onChange={handleChange} />
            <input name="email" placeholder="Email address" value={newsletterForm.email} onChange={handleChange} />
          </div>
          <textarea name="introduction" placeholder="Introduction" value={newsletterForm.introduction} onChange={handleChange} />
          <button type="submit" className="kw__philanthropy-news-submit">
            <span>Submit</span>
            <img src={buttonArrow} alt="" />
          </button>
        </form>
      </section>
    </div>
  );
};

export default Philanthropy;
